import { ActionIcon, Paper, Stack } from '@mantine/core'
import { FaForward, FaPause, FaPlay } from 'react-icons/fa'
import classes from './StartPauseSkipButtons.module.css'
import { NavigationDataResponse } from '@/api/navigationApi/types.gen'

const StartPauseSkipButtons = ({
  onPause,
  onResume,
  onStart,
  onSkipSegment,
  isStartDisabled,
  isPauseDisabled,
  isSkipDisabled,
  moduleState,
  isFreeride,
}: {
  moduleState?: NavigationDataResponse['route_module_state']
  onPause: () => void
  onStart: () => void
  onResume: () => void
  onSkipSegment: () => void
  isStartDisabled: boolean
  isPauseDisabled: boolean
  isSkipDisabled: boolean
  isFreeride: boolean
}) => {
  const isPaused = moduleState === 'Paused'

  // In freeride there is no scheduled route, so the driver can stop (pause) the
  // run or start it again (resume), but there are no segments to skip. The car
  // does not report a 'Driving' module state during freeride, so the stop/start
  // control is driven by the freeride flag (paused vs running) instead.
  const showPause = isFreeride ? !isPaused : moduleState === 'Driving'
  const showPlay = isFreeride ? isPaused : isPaused || moduleState === 'Fetched'
  const showSkip = !isFreeride && (moduleState === 'Driving' || isPaused)

  return (
    <Stack gap="xs" className={classes.actionButtons}>
      {showPause ? (
        <Paper p={0} shadow="xs" withBorder>
          <ActionIcon size={64} onClick={onPause} disabled={isPauseDisabled} variant="filled" color="blue">
            <FaPause />
          </ActionIcon>
        </Paper>
      ) : showPlay ? (
        <Paper p={0} shadow="xs" withBorder>
          <ActionIcon
            size={64}
            onClick={isPaused ? onResume : onStart}
            disabled={isStartDisabled}
            variant="filled"
            color="teal"
          >
            <FaPlay />
          </ActionIcon>
        </Paper>
      ) : null}
      {showSkip && (
        <Paper p={0} shadow="xs" withBorder>
          <ActionIcon size={64} onClick={onSkipSegment} disabled={isSkipDisabled} variant="filled" color="orange">
            <FaForward />
          </ActionIcon>
        </Paper>
      )}
    </Stack>
  )
}

export default StartPauseSkipButtons
